// extracted by mini-css-extract-plugin
export default {"link":"profilePolicy_link__OPdvv"};